import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "relative overflow-hidden px-8 pt-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  width: "80",
  height: "77",
  class: "absolute -top-10 -right-10 text-accent-yellow"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "120",
    height: "119",
    viewBox: "0 0 120 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "1",
      d: "M6.38128 49.1539C3.20326 32.893 13.809 17.1346 30.0699 13.9566L70.3846 6.07751C86.6455 2.89948 102.404 13.5052 105.582 29.7661L113.461 70.0808C116.639 86.3417 106.033 102.1 89.7724 105.278L49.4577 113.157C33.1968 116.335 17.4384 105.729 14.2604 89.4686L6.38128 49.1539Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_4 = { class: "text-2xl flex flex-col pb-4" }
const _hoisted_5 = { class: "text-3xl font-bold" }
const _hoisted_6 = { class: "text-3xl font-bold text-accent-purple" }
const _hoisted_7 = { class: "pb-4 text-xl" }
const _hoisted_8 = { class: "w-full flex justify-center items-center bg-neutral-20" }
const _hoisted_9 = { class: "w-full h-min flex flex-wrap place-content-center px-12 lg:px-32 sm:px-16 md:px-24 bg-background-light" }
const _hoisted_10 = { class: "font-bold text-3xl my-7 lg:my-12" }
const _hoisted_11 = { class: "bg-background-medium flex flex-wrap overflow-y-auto" }
const _hoisted_12 = { class: "px-12 space-y-6 my-7 lg:px-36 sm:px-16 md:px-24" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "text-md" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-accent-purple underline",
  href: "mailto:collectie@gent.be"
}, "collectie@gent.be", -1)
const _hoisted_16 = { class: "space-y-2 mb-4" }
const _hoisted_17 = { class: "text-md" }
const _hoisted_18 = {
  class: "text-accent-purple underline",
  href: "https://www.collectie.gent/over-het-project",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    large: false,
    scroll: true,
    "modal-state": _ctx.DisclaimerModalState.state,
    onHideModal: _ctx.closeDisclaimerModal,
    onShowModal: _ctx.openDisclaimerModal
  }, {
    small: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('disclaimer.small-1')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('disclaimer.small-2')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.t('disclaimer.small-3')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "flex-1 px-4 py-3 text-gray-500 hover:text-neutral-0 hover:bg-accent-purple duration-150 font-bold",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDisclaimerModal && _ctx.closeDisclaimerModal(...args)))
        }, "Ok!"),
        _createElementVNode("button", {
          class: "flex-1 px-4 py-3 text-gray-500 hover:text-neutral-0 hover:bg-accent-purple duration-150 font-bold",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDisclaimerModal && _ctx.openDisclaimerModal(...args)))
        }, "Meer info")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.t('disclaimer.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.t('disclaimer.content')) + " ", 1),
              _hoisted_15
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.t('disclaimer.content-2')) + " ", 1),
              _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.t('disclaimer.link')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('disclaimer.content-3')), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "onHideModal", "onShowModal"]))
}